import { ScrollControls } from '@react-three/drei'
import { Canvas } from '@react-three/fiber'
import { getProject } from "@theatre/core";
import { SheetProvider } from "@theatre/r3f";
import Effects from './Effects.jsx';
import Scene from './Scene.jsx';
import Storytelling from './Storytelling.jsx';
import theatreState from "./theatreState.json";

export default function Experience()
{
    const sheet = getProject("Fly Through", { state: theatreState }).sheet(
        "Scene"
      );
    // const sheet = getProject("Fly Through").sheet("Scene");

    return (
        <Canvas gl={{ preserveDrawingBuffer: true }}>
            <ScrollControls pages={7}>
                <SheetProvider sheet={sheet}>
                    {/* <Effects /> */}
                    <Storytelling />
                    <Scene />
                </SheetProvider>
            </ScrollControls>
        </Canvas>
    );
}